'use client';

import React, { useRef } from 'react';

import { Clock } from 'lucide-react';

import { Label } from './label.jsx';
import { TimePickerInput } from './time-picker-input.jsx';

function TimePicker({ date, setDate }) {
  const minuteRef = useRef(null);
  const hourRef = useRef(null);
  const secondRef = useRef(null);

  return (
    <div className="flex items-end gap-2">
      <div className="flex h-10 items-center">
        <Clock className="mr-2 size-4 text-muted-foreground" />
      </div>
      <div className="grid gap-1.5 text-center">
        <Label htmlFor="hours" className="text-xs">
          HH
        </Label>
        <TimePickerInput
          picker="hours"
          date={date}
          setDate={setDate}
          ref={hourRef}
          onRightFocus={() => minuteRef.current?.focus()}
        />
      </div>

      <div className="flex h-10 items-center text-xl font-bold leading-none">
        :
      </div>

      <div className="grid gap-1.5 text-center">
        <Label htmlFor="minutes" className="text-xs">
          MM
        </Label>
        <TimePickerInput
          picker="minutes"
          date={date}
          setDate={setDate}
          ref={minuteRef}
          onLeftFocus={() => hourRef.current?.focus()}
          onRightFocus={() => secondRef.current?.focus()}
        />
      </div>

      <div className="flex h-10 items-center text-xl font-bold leading-none">
        :
      </div>

      <div className="grid gap-1.5 text-center">
        <Label htmlFor="seconds" className="text-xs">
          SS
        </Label>
        <TimePickerInput
          picker="seconds"
          date={date}
          setDate={setDate}
          ref={secondRef}
          onLeftFocus={() => minuteRef.current?.focus()}
        />
      </div>
    </div>
  );
}

export { TimePicker };
